import { WasteCatagoryType } from "@utils/isValidWasteCategoryAndRoute";

export const mainCategories = [
  "graffiti_posters_and_stickers", // 0
  "dumped_rubbish", // 1
  "bin_bags", // 2
  "cardboard_boxes", // 3
  "Litter", // 4
  "dead_animals", // 5
  "Bins", // 6
  "dog_poo", // 7
  "street_cleaning", // 8
];

export const subCategories = [
  {
    name: "Graffiti",
    parentCategory: "graffiti_posters_and_stickers",
    parentCategoryLabel: "Graffiti, posters and stickers",
  },
  {
    name: "Posters",
    parentCategory: "graffiti_posters_and_stickers",
    parentCategoryLabel: "Graffiti, posters and stickers",
  },
  {
    name: "Stickers",
    parentCategory: "graffiti_posters_and_stickers",
    parentCategoryLabel: "Graffiti, posters and stickers",
  },
  {
    name: "Construction / DIY",
    parentCategory: "dumped_rubbish",
    parentCategoryLabel: "Dumped rubbish",
  },
  {
    name: "Household appliances",
    parentCategory: "dumped_rubbish",
    parentCategoryLabel: "Dumped rubbish",
  },
  {
    name: "Furniture",
    parentCategory: "dumped_rubbish",
    parentCategoryLabel: "Dumped rubbish",
  },
  {
    name: "Other dumped rubbish",
    parentCategory: "dumped_rubbish",
    parentCategoryLabel: "Dumped rubbish",
  },
  {
    name: "Bin bags",
    parentCategory: "bin_bags",
    parentCategoryLabel: "Bin bags",
  },
  {
    name: "Cardboard boxes",
    parentCategory: "cardboard_boxes",
    parentCategoryLabel: "Cardboard boxes",
  },
  {
    name: "Litter",
    parentCategory: "Litter",
    parentCategoryLabel: "Litter",
  },
  {
    name: "Dog poo",
    parentCategory: "dog_poo",
    parentCategoryLabel: "Dog poo",
  },
  {
    name: "Damaged, dirty or missing bin",
    parentCategory: "Bins",
    parentCategoryLabel: "Bins",
  },
  {
    name: "Full bin",
    parentCategory: "Bins",
    parentCategoryLabel: "Bins",
  },
  {
    name: "Street cleaning",
    parentCategory: "street_cleaning",
    parentCategoryLabel: "Street cleaning",
  },
  {
    name: "Dead animals",
    parentCategory: "dead_animals",
    parentCategoryLabel: "Dead animals",
  },
];

export const questions = [
  /** key should not change/update as it is being used as a filter for question */
  {
    key: "offensive",
    name: "Is it offensive?",
    parentSubcategories: ["Graffiti", "Posters", "Stickers"],
    fieldType: "Radio Button",
    response: "",
  },
  {
    key: "howBig",
    name: "How big is it?",
    parentSubcategories: ["Graffiti", "Posters", "Stickers"],
    fieldType: "Option",
    response: "",
  },
  {
    key: "surface",
    name: "What surface is it on?",
    parentSubcategories: ["Graffiti", "Posters", "Stickers"],
    fieldType: "Option",
    response: "",
  },
  {
    key: "howMuch",
    name: "How much is there?",
    parentSubcategories: [
      "Construction / DIY",
      "Household appliances",
      "Furniture",
      "Other dumped rubbish",
    ],
    fieldType: "Option",
    response: "",
  },
  {
    key: "howMany",
    name: "How many are there?",
    parentSubcategories: ["Bin bags", "Cardboard boxes"],
    fieldType: "Option",
    response: "",
  },
  {
    key: "binType",
    name: "What type of bin is it?",
    parentSubcategories: ["Full bin", "Damaged, dirty or missing bin"],
    fieldType: "Option",
    response: "",
  },
  {
    key: "binProblem",
    name: "What's wrong with the bin?",
    parentSubcategories: ["Damaged, dirty or missing bin"],
    fieldType: "Option",
    response: "",
  },
  {
    key: "cleaning",
    name: "What needs cleaning away?",
    parentSubcategories: ["Street cleaning"],
    fieldType: "Option",
    response: "",
  },
  {
    key: "animal",
    name: "What type of animal is it?",
    parentSubcategories: ["Dead animals"],
    fieldType: "Option",
    response: "",
  },
];

export const fieldOptions = [
  {
    parentQuestion: "How much is there?",
    options: [
      "Single item (1 bag)",
      "Car boot load (2-5 bags)",
      "Small van load (6-15 bags)",
      "Transit van load (16+ bags)",
    ],
  },
  {
    parentQuestion: "How many are there?",
    options: [
      "Single item (1 bag)",
      "Car boot load (2-5 bags)",
      "Small van load (6-15 bags)",
      "Transit van load (16+ bags)",
    ],
  },
  {
    parentQuestion: "How big is it?",
    options: [
      "Less than 1 square metre",
      "1 square metre to 3 square metres",
      "3 square metres plus",
    ],
  },
  {
    parentQuestion: "What surface is it on?",
    options: [
      "Stone",
      "Brick",
      "Wood",
      "Tarmac",
      "Concrete",
      "Metal",
      "Plastic",
      "Glass",
      "Other/not known",
    ],
  },
  {
    parentQuestion: "What needs cleaning away?",
    options: ["Other", "Human fouling", "Paint spillage", "Oil or grease"],
  },
  {
    parentQuestion: "What type of bin is it?",
    options: [
      "Black 4 wheeled bin",
      "Recycling bin",
      "Grit-salt bin",
      "Litter bin",
      "Food waste bin",
      "Large rubbish bin",
      "Micro recycling centre",
    ],
  },
  {
    parentQuestion: "What's wrong with the bin?",
    options: ["Replace bin", "Repair bin", "Clean bin"],
  },
  {
    parentQuestion: "What type of animal is it?",
    options: ["Dog", "Cat", "Rodent", "Bird", "Fox", "Badger", "Other"],
  },
];

/**
 * Refer to the documentation here: https://westminstergov.atlassian.net/wiki/spaces/REPORTIT/pages/253165667/Waste+Inference+API
 */
export enum WasteCategoryLabel {
  BINS = "Bins",
  CARDBOARD = "Cardboard",
  POSTERS_AND_STICKERS = "Posters and Stickers",
  POSTERS_OR_STICKERS = "Posters or Stickers",
  FURNITURE = "Furniture",
  BIN_BAGS = "Bin Bags",
  HOUSEHOLD_APPLIANCES = "Household Appliances",
  LITTER = "Litter",
  CONSTRUCTION_AND_DIY = "Construction and DIY",
  GRAFFITI = "Graffiti",
  OTHER_DUMPED_RUBBISH = "Other Dumped Rubbish",
  STREET_CLEANING = "Street Cleaning",
}

export enum SubCategoryName {
  GRAFFITI = "Graffiti",
  POSTERS = "Posters",
  STICKERS = "Stickers",
  CONSTRUCTION_DIY = "Construction / DIY",
  HOUSEHOLD_APPLIANCES = "Household appliances",
  FURNITURE = "Furniture",
  OTHER_DUMPED_RUBBISH = "Other dumped rubbish",
  BIN_BAGS = "Bin bags",
  CARDBOARD_BOXES = "Cardboard boxes",
  LITTER = "Litter",
  DOG_POO = "Dog poo",
  DAMAGED_DIRTY_MISSING_BIN = "Damaged, dirty or missing bin",
  FULL_BIN = "Full bin",
  STREET_CLEANING = "Street cleaning",
  DEAD_ANIMALS = "Dead animals",
}

export enum BinBagCategory {
  ONE = "1 bin bag",
  TWO_TO_FIVE = "2-5 bin bags",
  SIX_TO_FIFTEEN = "6-15 bin bags",
  MORE_THAN_FIFTEEN = ">15 bin bags",
}

const binBagOptions = fieldOptions.find(
  (f) => f.parentQuestion === questions.find((q) => q.key === "howMany")?.name,
)?.options;

export const binBagResponseMap = {
  [BinBagCategory.ONE]: binBagOptions?.[0] || "",
  [BinBagCategory.TWO_TO_FIVE]: binBagOptions?.[1] || "",
  [BinBagCategory.SIX_TO_FIFTEEN]: binBagOptions?.[2] || "",
  [BinBagCategory.MORE_THAN_FIFTEEN]: binBagOptions?.[3] || "",
};

export interface WasteCategoryOptionType {
  label: WasteCategoryLabel | SubCategoryName | string;
  value: WasteCatagoryType | string;
  parentCategoryValue: WasteCatagoryType;
  subCategoryName: SubCategoryName;
  parentCategoryLabel: string;
}

export const InferredWasteCategoryOptions: Array<
  Omit<WasteCategoryOptionType, "parentCategoryLabel">
> = [
  {
    label: WasteCategoryLabel.BINS,
    value: "bins",
    parentCategoryValue: "bins",
    subCategoryName: SubCategoryName.DAMAGED_DIRTY_MISSING_BIN,
  },
  {
    label: WasteCategoryLabel.CARDBOARD,
    value: "cardboard_boxes",
    parentCategoryValue: "cardboard_boxes",
    subCategoryName: SubCategoryName.CARDBOARD_BOXES,
  },
  {
    label: WasteCategoryLabel.POSTERS_AND_STICKERS,
    value: "posters_and_stickers",
    parentCategoryValue: "graffiti_posters_and_stickers",
    subCategoryName: SubCategoryName.POSTERS,
  },
  {
    label: WasteCategoryLabel.POSTERS_OR_STICKERS,
    value: "posters_and_stickers",
    parentCategoryValue: "graffiti_posters_and_stickers",
    subCategoryName: SubCategoryName.POSTERS,
  },
  {
    label: WasteCategoryLabel.FURNITURE,
    value: "furniture",
    parentCategoryValue: "dumped_rubbish",
    subCategoryName: SubCategoryName.FURNITURE,
  },
  {
    label: WasteCategoryLabel.BIN_BAGS,
    value: "bin_bags",
    parentCategoryValue: "bin_bags",
    subCategoryName: SubCategoryName.BIN_BAGS,
  },
  {
    label: WasteCategoryLabel.HOUSEHOLD_APPLIANCES,
    value: "household_appliances",
    parentCategoryValue: "dumped_rubbish",
    subCategoryName: SubCategoryName.HOUSEHOLD_APPLIANCES,
  },
  {
    label: WasteCategoryLabel.LITTER,
    value: "Litter",
    parentCategoryValue: "litter",
    subCategoryName: SubCategoryName.LITTER,
  },
  {
    label: WasteCategoryLabel.CONSTRUCTION_AND_DIY,
    value: "Construction / DIY",
    parentCategoryValue: "dumped_rubbish",
    subCategoryName: SubCategoryName.CONSTRUCTION_DIY,
  },
  {
    label: WasteCategoryLabel.GRAFFITI,
    value: "Graffiti",
    parentCategoryValue: "graffiti_posters_and_stickers",
    subCategoryName: SubCategoryName.GRAFFITI,
  },
  {
    label: WasteCategoryLabel.OTHER_DUMPED_RUBBISH,
    value: "Other Dumped Rubbish",
    parentCategoryValue: "dumped_rubbish",
    subCategoryName: SubCategoryName.OTHER_DUMPED_RUBBISH,
  },
  {
    label: WasteCategoryLabel.STREET_CLEANING,
    value: "Street Cleaning",
    parentCategoryValue: "street_cleaning",
    subCategoryName: SubCategoryName.STREET_CLEANING,
  },
  {
    label: SubCategoryName.DOG_POO,
    value: "Dog poo",
    parentCategoryValue: "dog_poo",
    subCategoryName: SubCategoryName.DOG_POO,
  },
  {
    label: SubCategoryName.DEAD_ANIMALS,
    value: "Dead animals",
    parentCategoryValue: "dead_animals",
    subCategoryName: SubCategoryName.DEAD_ANIMALS,
  },
  {
    label: SubCategoryName.DAMAGED_DIRTY_MISSING_BIN,
    value: "Damaged, dirty or missing bin",
    parentCategoryValue: "bins",
    subCategoryName: SubCategoryName.DAMAGED_DIRTY_MISSING_BIN,
  },
  {
    label: SubCategoryName.FULL_BIN,
    value: "Full bin",
    parentCategoryValue: "bins",
    subCategoryName: SubCategoryName.FULL_BIN,
  },
  {
    label: SubCategoryName.POSTERS,
    value: "Posters",
    parentCategoryValue: "graffiti_posters_and_stickers",
    subCategoryName: SubCategoryName.POSTERS,
  },
  {
    label: SubCategoryName.STICKERS,
    value: "Stickers",
    parentCategoryValue: "graffiti_posters_and_stickers",
    subCategoryName: SubCategoryName.STICKERS,
  },
  {
    label: SubCategoryName.CARDBOARD_BOXES,
    value: "Cardboard boxes",
    parentCategoryValue: "cardboard_boxes",
    subCategoryName: SubCategoryName.CARDBOARD_BOXES,
  },
  {
    label: "Graffiti, posters and stickers",
    value: "Graffiti, posters and stickers",
    parentCategoryValue: "graffiti_posters_and_stickers",
    subCategoryName: SubCategoryName.GRAFFITI,
  },
  {
    label: "Dumped rubbish",
    value: "Dumped rubbish",
    parentCategoryValue: "dumped_rubbish",
    subCategoryName: SubCategoryName.OTHER_DUMPED_RUBBISH,
  },
];

export const BIN_BAG_DETECTOR_THRESHOLD = 0.2;
export const CLASSIFICATION_CONFIDENCE_THRESHOLD = 0.5;
